import { IonBackButton, IonButtons, IonHeader, IonTitle, IonToolbar, isPlatform } from '@ionic/react';

// We want to display an translucent header like native apps on iOS but it's possible only on iOS so we need to check the platform

export const IosHeader: React.FC<{ title: string; backText?: string; backLocation?: string }> = ({
    title,
    backText,
    backLocation = '/',
}) => {
    if (!isPlatform('ios')) {
        return null;
    }

    return (
        <IonHeader translucent={true}>
            <IonToolbar>
                <>
                    <IonTitle>{title}</IonTitle>
                    {backText && (
                        <IonButtons slot="start">
                            <IonBackButton defaultHref={backLocation} text={backText || 'Retour'} />
                        </IonButtons>
                    )}
                </>
            </IonToolbar>
        </IonHeader>
    );
};
